import {styled} from "@mui/material";
import { getResponsiveCSS } from '@utils/cssHelpers';

export const Wrapper = styled('div')({}, getResponsiveCSS('width', 780, 1130));
